/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Stack, Button, Fab } from "@mui/material";
import React from "react";
import IconButtonLegalbird from "@/src/components/legalbird/IconButtonLegalbird/IconButtonLegalbird.tsx";
import { Add, AddIcCall, ArrowUpward, NoteAdd } from "@mui/icons-material";
import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView.tsx";

export default function ButtonStyleguide() {
  return (
    <>
      <StyleguideView title={"Contained"}>
        <Stack direction={"row"} sx={{ alignItems: "center", flexWrap: "wrap", gap: "2rem" }}>
          <Button variant={"contained"}>Contained Medium</Button>
          <Button variant={"contained"} endIcon={<Add />}>
            Contained Medium
          </Button>
          <Button variant={"contained"} size={"small"}>
            Contained Small
          </Button>
          <Button variant={"contained"} size={"small"} endIcon={<Add />}>
            Contained Small
          </Button>
        </Stack>
      </StyleguideView>
      <StyleguideView title={"Outline"}>
        <Stack direction={"row"} sx={{ alignItems: "center", flexWrap: "wrap", gap: "2rem" }}>
          <Button variant={"outlined"}>Outlined Medium</Button>
          <Button variant={"outlined"} endIcon={<Add />}>
            Outlined Medium
          </Button>
          <Button variant={"outlined"} size={"small"}>
            Outlined Small
          </Button>
          <Button variant={"outlined"} size={"small"} endIcon={<Add />}>
            Outlined Small
          </Button>
        </Stack>
      </StyleguideView>
      <StyleguideView title={"Text"}>
        <Stack direction={"row"} sx={{ alignItems: "center", flexWrap: "wrap", gap: "2rem" }}>
          <Button variant={"text"}>Text Medium</Button>
          <Button variant={"text"} endIcon={<Add />}>
            Text Medium
          </Button>
          <Button variant={"text"} size={"small"}>
            Text Small
          </Button>
          <Button variant={"text"} size={"small"} endIcon={<Add />}>
            Text Small
          </Button>
        </Stack>
      </StyleguideView>
      <StyleguideView title={"Icon Button"}>
        <Stack direction={"row"} sx={{ alignItems: "center", flexWrap: "wrap", gap: "2rem" }}>
          <IconButtonLegalbird label="Add button" variant={"contained"} aria-label="Icon Button">
            <Add />
          </IconButtonLegalbird>
          <IconButtonLegalbird label="AddIcCall button" variant={"contained"} aria-label="Icon Button">
            <AddIcCall />
          </IconButtonLegalbird>
          <IconButtonLegalbird label="NoteAdd button" variant={"contained"} aria-label="Icon Button">
            <NoteAdd />
          </IconButtonLegalbird>
        </Stack>
      </StyleguideView>
      <StyleguideView title={"Floating Action Button"}>
        <Stack direction={"row"} sx={{ alignItems: "center", flexWrap: "wrap", gap: "2rem" }}>
          <Fab color="primary">
            <ArrowUpward />
          </Fab>
        </Stack>
      </StyleguideView>
    </>
  );
};
